import { createErrorTransformer } from 'store/queries/utils.ts'
import { Flow } from 'types/logging.ts'
import { boltBackend } from '../index.ts'
import { ResendMailPayload } from './types.ts'
import { Methods } from 'types/request.ts'

export const prospectsBoltBackend = boltBackend.injectEndpoints({
  endpoints: (builder) => ({
    // MUTATIONS
    // ---------
    resendMail: builder.mutation<void, ResendMailPayload>({
      query: ({ opportunityId }) => ({
        method: Methods.POST,
        url: `/resources/prospects/${opportunityId}/resend-mail`
      }),
      transformErrorResponse: createErrorTransformer(`[${Flow.PROSPECTS}:resendOpportunityEmail]`)
    })
  })
})

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  // Mutations
  useResendMailMutation
} = prospectsBoltBackend
